import { useState } from 'react'

import { Icon } from '../../UI'

const FAQItem = ({ question }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen((prevState) => !prevState)
  }

  return (
    <button
      role="switch"
      type="button"
      aria-checked={String(isOpen)}
      className={`w-full px-[32px] rounded-[16px] flex items-start flex-col transition-all duration-200 ease ${isOpen ? 'bg-[#FEEBDD] py-[32px]' : 'py-[16px] bg-transparent'}`}
      onClick={handleClick}
    >
      <div className="w-full flex items-center">
        <Icon
          name={isOpen ? 'minus-circle' : 'plus-circle'}
          className={`w-[24px] h-[24px] mr-[24px] transition-colors duration-200 ease ${isOpen ? 'text-[#F67443]' : 'text-[#FDFDFD]'}`}
        />

        <h4
          className={`text-lg font-medium transition-colors duration-200 ease ${isOpen ? 'text-primary-100' : 'text-[#FDFDFD]'}`}
        >
          {question.question}
        </h4>
      </div>

      <p
        className={`ml-[48px] text-base text-primary-100 text-left transition-all duration-200 ease ${isOpen ? 'opacity-100 mt-[20px] h-auto' : 'select-none h-0 opacity-[.02] mt-0'}`}
      >
        {question.answer}
      </p>
    </button>
  )
}

export default FAQItem
